import { VTA_LOOKBACK_WINDOW_INPUT_TYPE } from '../components/VtaLookBackWindowField/VtaLookbackWindowInputType';

export const CONVERSION_DEFAULTS = {
    lookBackWindow: 30,
    vtaLookBackWindow: {
        type: VTA_LOOKBACK_WINDOW_INPUT_TYPE.HOURS,
        value: 24,
    },
};
